import { Injectable } from '@angular/core';
import { ModalSideComponent } from '../components/modal-side/modal-side.component';

@Injectable({
  providedIn: 'root'
})
export class ModalTribeServiceService {

  constructor() {
    console.log('service modal', this.modals);
  }
  private modals: ModalSideComponent[] = [];
    add(modal: ModalSideComponent) {
        // ensure component has a unique id attribute
        if (!modal.id || this.modals.find(x => x.id === modal.id)) {
         console.log('modal list created',this.modals);
            // throw new Error('modal must have a unique id attribute');
        }

        // add modal to array of active modals
        this.modals.push(modal);
    }

    remove(modal: ModalSideComponent) {
        // remove modal from array of active modals
        this.modals = this.modals.filter(x => x === modal);
        console.log('modal list remove',this.modals);
    }

    open(id: string) {
      // console.log('id modal:', id);
        // open modal specified by id
        console.log('modal open ',id);
        const modal = this.modals.find(x => x.id === id);

        if (!modal) {
            throw new Error(`modal '${id}' not found`);
        }

        modal.open();
    }

    close() {
        // close the modal that is currently open
        const modal = this.modals.find(x => x.isOpen);
        this.modals = [];
        modal?.close();

    }
}
